var $ = require('jquery');
var ko = require('knockout');
var geo = require('./../../blocks/geo');
var WS = require('../../../scripts/ws');
var Dialog = require("../../blocks/dialog");
require('../../../scripts/validation');

$(function () {
    function AgentSearchViewModel(element) {
        var self = this;
        const serviceOutageDisplayTimeout = 15000;
        var serviceOutageDisplayedRecently = false;

        var $element = $(element);
        var $zipForm = $element.find('.ws-find-a-rep__zip-form');
        var geolocationAlertSelector = ".ws-dialog--geolocation-alert";
        var serviceOutageSelector = ".ws-dialog--service-outage";
        var resultsPage = $element.data('results-page');
        var searchTypes = $element.data('search-types');
        var prefillForm = $element.data('prefill-form');
        var defaultSearchType = searchTypes.indexOf('location') >= 0 ? 'location' : 'zip';
        var queryStringSearchType = WS.queryString['key'];
        var queryStringSearchValue = WS.queryString['value'];
        var initialSearchType = queryStringSearchType && prefillForm ? (queryStringSearchType === 'loc' ? 'location' : queryStringSearchType) : defaultSearchType;

        self.agents = ko.observableArray([]);
        self.errorMessage = ko.observable('');
        self.searchString = ko.observable('');

        self.officeRepSearchType = ko.observable('office');
        self.searchType = ko.observable(initialSearchType);

        self.zip = ko.observable(initialSearchType === 'zip' ? queryStringSearchValue : '');
        self.status = ko.observable('');
        self.active = ko.observable(false);
        self.xhr = null;

        self.hasAgents = ko.computed(function() {
            return self.agents().length > 0;
        }, this);

        self.search = function() {
            if (self.searchType() === 'location') {
                return self.searchByLocation();
            } else {
                return self.searchByZip();
            }
        };

        self.searchByLocation = function() {
            var geoOptions = {
                timeout: 10 * 1000,
                maximumAge: 5 * 60 * 1000
            }

            function geoSuccess(position) {
                self.errorMessage('');
                window.location.href = resultsPage + '?key=loc&value=' + position.coords.latitude + ',' + position.coords.longitude;
            };

            function geoError(error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        self.errorMessage('Geolocation permission denied.');
                        var $geolocationDialog = $('body').find(geolocationAlertSelector);
                        if ($geolocationDialog.length) {
                            Dialog.openDialog($geolocationDialog);
                        } else {
                            // call the api to get the service outage modal content
                            var url = '/api/sitecore/Utility/GeolocationAlertModal';
                            $.get(url).then(onGeolocationAlertModalSuccess, onModalError);
                        }
                        break;
                    case error.TIMEOUT:
                        self.errorMessage('Timeout occurred while getting position data.');
                        break;
                    case error.POSITION_UNAVAILABLE:
                        self.errorMessage('Position unavailable.');
                        break;
                    default:
                        self.errorMessage('Unknown error.');
                        break;
                }
            };

            var wsGeo = new geo.WsGeo();
            wsGeo.getLocation(geoSuccess, geoError, geoOptions);
        };

        self.searchByZip = function () {
            // setting errorPlacement callback to an empty function prevents showing error labels
            $zipForm.validate({ errorPlacement: function(error, element) {} });
            if ($zipForm.valid()) {
                window.location.href = resultsPage + '?key=zip&value=' + self.zip();
            }
        }

        self.zipFormSubmit = function () {
            // submitting the zip form by pressing Enter in the text box fires before the zip observable value is updated (updated on loss of focus), so we need to force the update so the correct value is used
            self.zip($zipForm.find('input[name=zip]').val());
            return self.search();
        }

        function searchAgents(newValue) {
            if (newValue.length < 3) {
                self.agents([]);
                self.errorMessage('');
                self.active(false);
            } else {
                var url = '/api/sitecore/AgentApi/SearchByLastName?searchInput=' + newValue;

                if (self.xhr !== null && self.xhr.readyState !== 4) {
                    self.xhr.abort();
                }

                self.xhr = $.ajax({
                    type: "GET",
                    url: url,
                    dataType: "json",
                    success: onSearchSuccess,
                    error: onSearchError
                });
            }
        }

        function onSearchSuccess(data) {
            self.active(true);
            self.agents(data);

            if (self.agents().length === 0) {
                self.errorMessage('no results found');
            } else {
                self.errorMessage('');
            }
        }

        function onSearchError(xhr) {
            self.active(true);

            if (xhr.statusText.toLowerCase() !== 'abort') {
                self.agents([]);
                self.errorMessage("");

                // display the service outage modal once, not on every keystroke
                if (!serviceOutageDisplayedRecently) {
                    var $serviceOutageDialog = $('body').find(serviceOutageSelector);
                    if ($serviceOutageDialog.length) {
                        serviceOutageDisplayedRecently = true;
                        Dialog.openDialog($serviceOutageDialog);
                    } else {
                        // call the api to get the service outage modal content
                        var url = `/api/sitecore/Utility/ServiceOutageModal?itemId=${$element.data("ws-item-guid")}`;
                        $.get(url).then(onServiceOutageModalSuccess, onModalError);
                    }
                }
            }
        }

        function onServiceOutageModalSuccess(content) {
            serviceOutageDisplayedRecently = true;
            $('body').append(content);
            var $serviceOutageDialog = $('body').find(serviceOutageSelector);
            Dialog.openDialog($serviceOutageDialog);
            setTimeout(() => serviceOutageDisplayedRecently = false, serviceOutageDisplayTimeout);
        }

        function onGeolocationAlertModalSuccess(content) {
            $('body').append(content);
            var $geolocationAlertDialog = $('body').find(geolocationAlertSelector);
            Dialog.openDialog($geolocationAlertDialog);
        }

        function onModalError() {
            self.errorMessage("Service unavailable.");
        }

        self.searchString.subscribe(searchAgents);
    }

    $('.ws-find-a-rep').each(function(index, item) {
        ko.applyBindings(new AgentSearchViewModel(item), item);
    });
});